import IDCardApprovals from './components/IDCards';
import PanCardApprovals from './components/PANCards';

export const TAB_KEYS = {
  ID_CARDS: 'id-cards',
  PAN_CARDS: 'pan-cards'
};

export enum EntityType {
  AGENT_ID = 'AGENT_ID',
  AGENT_PAN_CARD = 'AGENT_PAN_CARD'
}

export const APPROVAL_TABS = [
  {
    key: TAB_KEYS.ID_CARDS,
    value: 'ID Cards',
    component: IDCardApprovals,
    featureFlagKey: 'isAgentIdCardDetailsVisible'
  },
  {
    key: TAB_KEYS.PAN_CARDS,
    value: 'PAN Cards',
    component: PanCardApprovals,
    featureFlagKey: 'panCardApprovalFlow'
  }
];

export const initialPaginationParams = {
  page: 1,
  size: 10,
  query: ''
};

export const PENDING_APPROVALS_KEY = 'PENDING_APPROVALS';
